import { AbstractMutableMapyktux9ubhc1g as AbstractMutableMap } from './AbstractMutableMap.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import {
  HashMapKeys28ggmxpft3hz9 as HashMapKeys,
  HashMapValues3umcxpfyfunqf as HashMapValues,
  HashMapEntrySet29p2ksc4wcy5i as HashMapEntrySet,
} from './HashMapEntry.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashMap(_this__u8e3s4) {
  _this__u8e3s4.p8_1 = null;
}
var HashMapClass;
function HashMap() {
  if (HashMapClass === VOID) {
    class $ extends AbstractMutableMap() {
      static q8(internalMap) {
        var $this = this.q7();
        init_kotlin_collections_HashMap($this);
        $this.o8_1 = internalMap;
        return $this;
      }
      static r8() {
        return this.q8(InternalHashMap().c9());
      }
      static d9(initialCapacity, loadFactor) {
        return this.q8(InternalHashMap().e9(initialCapacity, loadFactor));
      }
      static f9(initialCapacity) {
        return this.d9(initialCapacity, 1.0);
      }
      static g9(original) {
        return this.q8(InternalHashMap().h9(original));
      }
      a5() {
        this.o8_1.a5();
      }
      s4(key) {
        return this.o8_1.i9(key);
      }
      t4(value) {
        return this.o8_1.t4(value);
      }
      u7() {
        return HashMapKeys().k9(this.o8_1);
      }
      x7() {
        return HashMapValues().m9(this.o8_1);
      }
      l3() {
        var tmp0_elvis_lhs = this.p8_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = HashMapEntrySet().o9(this.o8_1);
          this.p8_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      u4(key) {
        return this.o8_1.u4(key);
      }
      x4(key, value) {
        return this.o8_1.x4(key, value);
      }
      y4(key) {
        return this.o8_1.y4(key);
      }
      q2() {
        return this.o8_1.q2();
      }
      z4(from) {
        return this.o8_1.z4(from);
      }
    }
    initMetadataForClass($, 'HashMap', $.r8, VOID, [KtMutableMap()]);
    HashMapClass = $;
  }
  return HashMapClass;
}
//region block: exports
export {
  HashMap as HashMap1a0ld5kgwhmhv,
};
//endregion

//# sourceMappingURL=HashMap.mjs.map
